export const onCopyClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};
